export default {
  // Region Selector
  "region.hello": "Hola! Estas dirigiendote al site de",
  "region.continue": "Puedes continuar en el sitio actual o ir al sitio local de tu pais.",
  "region.region": "Region",
  "region.goTo": "Ir a",
  "region.stayIn": "Seguir en",
  "region.change": "Cambiar region",
  "region.detecting": "Detectando tu ubicacion...",
  "region.selectCountry": "Selecciona tu pais o region",
  "region.searchPlaceholder": "Buscar pais o region...",
  "region.noResults": "No se encontraron resultados",
  "region.detected": "Detectado",
  "region.close": "Cerrar",
  "region.changeSelection": "Cambiar seleccion",
  "region.spanish": "Espanol",
  "region.english": "English",
  "continent.Americas": "Americas",
  "continent.Europe": "Europa",
  "continent.Asia": "Asia",
  "continent.Africa": "Africa",
  "continent.Oceania": "Oceania",
  "continent.Global": "Global",

  // Hero
  "hero.tag1": "CSOC 24/7",
  "hero.title1": "Protegemos tu",
  "hero.highlight1": "futuro digital",
  "hero.subtitle1": "Soluciones de ciberseguridad de clase mundial para empresas que exigen el mas alto nivel de proteccion",
  "hero.cta1": "Explorar soluciones",
  "hero.secondary1": "Solicitar demo",
  "hero.tag2": "AI-Powered",
  "hero.title2": "Inteligencia artificial",
  "hero.highlight2": "contra amenazas",
  "hero.subtitle2": "Plataforma de ciberinteligencia con machine learning que detecta y neutraliza ataques en tiempo real",
  "hero.cta2": "Ver plataforma",
  "hero.secondary2": "Casos de exito",
  "hero.tag3": "Zero Trust",
  "hero.title3": "Infraestructura",
  "hero.highlight3": "blindada",
  "hero.subtitle3": "Proteccion multicapa para entornos cloud, endpoints y redes corporativas con monitoreo continuo",
  "hero.cta3": "Servicios Cloud",
  "hero.secondary3": "Consultoria",
  "hero.tag4": "Presencia Global",
  "hero.title4": "America y Europa",
  "hero.highlight4": "una mision",
  "hero.subtitle4": "Sin limites, con presencia en paises como EEUU, Peru, Chile, Colombia, Ecuador, Mexico y Europa con SOCs certificados y calificaciones sobresalientes de 4.5/5",
  "hero.cta4": "Conocenos",
  "hero.secondary4": "Ubicanos",
  "hero.verCybersoc": "Ver CyberSOC",
  "hero.videoPlaying": "En reproduccion",
  "hero.videoDesc": "Mira como protegemos infraestructuras criticas en tiempo real",
  "hero.scroll": "Scroll",

  // Stats
  "stat.countries": "Presencia",
  "stat.rating": "Rating SOC",
  "stat.iso": "27001:2013",
  "stat.monitoring": "Monitoreo",

  // Navbar
  "nav.home": "Inicio",
  "nav.about": "Quienes Somos",
  "nav.solutions": "Soluciones",
  "nav.services": "Servicios",
  "nav.trainings": "Secure Academy",
  "nav.datacenter": "Datacenter",
  "nav.contact": "Contáctanos",
  "nav.support": "Support",
  "nav.quote": "¿Te ayudamos?",
  "nav.cybersoc": "CyberSOC",

  // Nav dropdowns - Empresa
  "nav.dropdown.vision": "Vision y Mision",
  "nav.dropdown.milestones": "Hitos",
  "nav.dropdown.recognitions": "Reconocimientos",

  // Nav dropdowns - Soluciones
  "nav.dropdown.dataSecurity": "Data Security",
  "nav.dropdown.endpointSecurity": "Endpoint Security",
  "nav.dropdown.cloudSecurity": "Cloud Security",
  "nav.dropdown.appSecurity": "Application Security",
  "nav.dropdown.netSecurity": "Networking Security",
  "nav.dropdown.cyberintel": "Ciberinteligencia",

  // Nav dropdowns - Servicios
  "nav.dropdown.consulting": "Consultoría de seguridad",
  "nav.dropdown.securityConsulting": "Consultoría de Ciberseguridad",
  "nav.dropdown.cybersoc": "CyberSOC 24/7/365",
  "nav.dropdown.productEng": "Ingenieria de Productos",
  "nav.dropdown.secureAcademy": "Secure Academy",

  // Nav dropdowns - Datacenter
  "nav.dropdown.dcInfra": "Data Center e Infraestructura",
  "nav.dropdown.dcCloud": "Servicios Cloud",
  "nav.dropdown.dcSecurity": "Servicios de Seguridad",
  "nav.dropdown.dcNetwork": "Redes y Comunicaciones",
  "nav.dropdown.dcCyber": "Ciberseguridad",
  "nav.dropdown.dcManaged": "Servicios Gestionados (SOC/NOC)",
  "nav.dropdown.dcDatabase": "Bases de Datos y Resguardo",
  "nav.dropdown.dcBCDR": "Continuidad del Negocio y Disaster Recovery",
  "nav.dropdown.dcSales": "Venta y renting de software/hardware",
  "nav.dropdown.dcProjectConsulting": "Consultoria de Proyectos",

  // Solutions cards
  "sol.dataSecurity.subtitle": "Proteccion de datos criticos con cifrado avanzado, prevencion de perdida de datos (DLP) y cumplimiento normativo.",
  "sol.endpointSecurity.subtitle": "Proteccion avanzada de endpoints con EDR/XDR, prevencion de intrusiones y respuesta automatizada.",
  "sol.cloudSecurity.subtitle": "Proteccion integral para AWS, Azure y GCP. Seguridad de contenedores, DevSecOps y cumplimiento multi-cloud.",
  "sol.appSecurity.subtitle": "DevSecOps, SAST/DAST, revision de codigo seguro y proteccion de APIs para ciclo de vida de desarrollo seguro.",
  "sol.netSecurity.subtitle": "Segmentacion de red, Next-Gen Firewall, IDS/IPS y proteccion contra ataques de red con arquitectura Zero Trust.",
  "sol.cyberintel.title": "Ciberinteligencia",
  "sol.cyberintel.subtitle": "Inteligencia de amenazas proactiva, dark web monitoring, indicadores de compromiso (IoC) y analisis de actores de amenazas.",

  // Services cards
  "svc.consulting.title": "Consultoría de seguridad",
  "svc.consulting.subtitle": "Asesoria especializada para fortalecer la postura de seguridad de tu organizacion con metodologias probadas.",
  "svc.securityConsulting.title": "Consultoría de Ciberseguridad",
  "svc.securityConsulting.subtitle": "Servicios tecnicos avanzados de ethical hacking, pentesting y analisis forense para identificar vulnerabilidades.",
  "svc.cybersoc.title": "CyberSOC 24/7/365",
  "svc.cybersoc.subtitle": "Centro de Operaciones de Seguridad gestionado 24/7 con monitoreo continuo, deteccion de amenazas y respuesta a incidentes.",
  "svc.productEng.title": "Ingenieria de Productos",
  "svc.productEng.subtitle": "Implementacion, soporte tecnico y administracion remota de soluciones de seguridad de primer nivel.",
  "svc.secureAcademy.title": "Secure Academy",
  "svc.secureAcademy.subtitle": "Programas de certificacion oficial y formacion especializada en ciberseguridad con instructores certificados.",

  // Services items
  "svc.consulting.item1": "Assessment Tecnologico de Seguridad y Redes",
  "svc.consulting.item2": "Assessment de Seguridad de la Informacion",
  "svc.consulting.item3": "Clasificacion de Informacion",
  "svc.consulting.item4": "Security Awareness",
  "svc.consulting.item5": "Implantacion SGSI",
  "svc.consulting.item6": "Adaptacion y Cumplimiento de la Ley de Proteccion de Datos Personales",
  "svc.consulting.item7": "Cumplimiento PCI",
  "svc.consulting.item8": "Analisis de Riesgos",
  "svc.consulting.item9": "Assessment de Ciberseguridad",
  "svc.consulting.item10": "Plan de Recuperacion ante Desastres (DRP)",
  "svc.consulting.item11": "Plan de Continuidad de Negocios (BCP)",
  "svc.consulting.item12": "Asesoramiento para Certificacion ISO 27001",

  "svc.securityConsulting.item1": "Evaluacion de Hardening",
  "svc.securityConsulting.item2": "Ethical Hacking en Cajeros Automaticos",
  "svc.securityConsulting.item3": "Capacitacion en Ethical Hacking",
  "svc.securityConsulting.item4": "Ethical Hacking",
  "svc.securityConsulting.item5": "Analisis de Vulnerabilidades",
  "svc.securityConsulting.item6": "Penetration Test",
  "svc.securityConsulting.item7": "Seguridad SCADA",
  "svc.securityConsulting.item8": "Analisis Forense",
  "svc.securityConsulting.item9": "Red Team",
  "svc.securityConsulting.item10": "Analisis de Codigo Fuente",
  "svc.securityConsulting.item11": "Evaluacion de Redes Inalambricas",
  "svc.securityConsulting.item12": "Threat Hunting",

  "svc.cybersoc.item1": "Monitoreo y Notificacion del Estado de Salud de las Plataformas",
  "svc.cybersoc.item2": "Monitoreo y Notificacion de los Eventos de Seguridad y Correlacion",
  "svc.cybersoc.item3": "Ciberinteligencia",
  "svc.cybersoc.item4": "Monitoreo de Amenazas Externas - Boletines de Seguridad",

  "svc.productEng.item1": "Soporte Tecnico",
  "svc.productEng.item2": "Administracion Remota",
  "svc.productEng.item3": "Capacitaciones",

  "svc.secureAcademy.item1": "ATC Checkpoint",
  "svc.secureAcademy.item2": "ISC2 Official Training",

  // Industries
  "industry.banca": "Banca y Finanzas",
  "industry.telecom": "Telecom y TIC",
  "industry.seguros": "Seguros y AFP",
  "industry.mineria": "Mineria, Energia e Hidrocarburos",
  "industry.gobierno": "Gobierno",
  "industry.educacion": "Educacion",
  "industry.salud": "Salud y Farmaceutica",
  "industry.retail": "Retail y E-commerce",
  "industry.manufactura": "Manufactura",
  "industry.transporte": "Transporte y Logistica",
  "industry.otros": "Otras Industrias",

  // Trainings
  "training.ethicalHacking.category": "Curso tecnico",
  "training.ethicalHacking.title": "Ethical Hacking y Pentesting Avanzado",
  "training.socAnalyst.category": "Certificacion",
  "training.socAnalyst.title": "SOC Analyst Level 1: Deteccion y Respuesta",
  "training.cloudSecurity.category": "Workshop",
  "training.cloudSecurity.title": "Cloud Security para Empresas Corporativas",
  "training.secureAcademy.category": "Programa",
  "training.secureAcademy.title": "Secure Academy: Formacion Continua en Ciberseguridad",

  // Quick Actions
  "quick.elegirnos.title": "Por que elegirnos?",
  "quick.elegirnos.subtitle": "Descubre nuestra ventaja competitiva",
  "quick.ubicacion.title": "Ubicanos",
  "quick.ubicacion.subtitle": "America y Europa con presencia directa",
  "quick.alertas.title": "Alertas de seguridad",
  "quick.alertas.subtitle": "Monitoreo global en tiempo real",
  "quick.consulta.title": "Cotizacion rapida",
  "quick.consulta.subtitle": "Tarifas personalizadas para tu empresa",

  // Footer links
  "footer.link.nosotros": "Nosotros",
  "footer.link.alertas": "Alertas y reportes",
  "footer.link.partners": "Partners",
  "footer.link.denuncias": "Canal de Denuncias",
  "footer.link.politicas": "Politicas Corporativas",
  "footer.link.trabaja": "Trabaja con nosotros",
  "footer.link.soluciones": "Soluciones",
  "footer.link.cotizar": "Cotizar servicios",
  "footer.link.servicios": "Servicios",
  "footer.link.datacenter": "Datacenter",
  "footer.link.cybersoc": "CyberSOC",
  "footer.link.libro": "Libro de reclamaciones",
  "footer.link.datos": "Tratamiento de datos personales",
  "footer.link.cookies": "Politica de Cookies",
  "footer.link.privacidad": "Politica de Privacidad",
  "footer.link.terms": "Términos y Condiciones",
  "footer.link.videovigilancia": "Politica de videovigilancia",
  "footer.link.sst": "Politica de SST",
  "footer.link.arcoManual": "Manual de derechos ARCO",
  "footer.link.arcoForm": "Formulario de solicitud de derechos ARCO",
  "footer.link.osiptel": "Guia de presentacion de Reclamos de OSIPTEL",
  "footer.link.reclamoForm": "Formulario de reclamo",
  "footer.link.apelacionForm": "Formulario de apelacion",
  "footer.link.quejaForm": "Formulario de queja",
  "footer.link.cookiePrefs": "Preferencias de cookies",
  "footer.link.oficina": "Oficina",
  "footer.link.ejecutivo": "Contactar con un ejecutivo",

  // Certificaciones y Alianzas
  "cert.tag": "Respaldo internacional",
  "cert.title": "Certificaciones y",
  "cert.highlight": "Alianzas",
  "cert.subtitle": "Trabajamos con los lideres mundiales en tecnologia para garantizar soluciones de la mas alta calidad",

  // About
  "about.teamTitle": "Somos Openlab Secure",
  "about.teamSubtitle": "Un equipo global unido por una mision",
  "about.tag": "Empresa",
  "about.title": "Protegemos lo que",
  "about.highlight": "mas valoras",
  "about.quote": "Mas de 200 especialistas trabajando para proteger lo que mas valoras, con presencia directa en America y Europa.",
  "about.statCountries": "Paises",
  "about.statCountriesDesc": "America y Europa",
  "about.statSpecialists": "Especialistas",
  "about.statSpecialistsDesc": "Certificados",
  "about.statRating": "Rating",
  "about.statRatingDesc": "Prime Defense",
  "about.statMonitoring": "Monitoreo",
  "about.statMonitoringDesc": "SOC activo",
  "about.valueTrust": "Confianza",
  "about.valueTrustDesc": "Protegemos los activos mas criticos con integridad y transparencia.",
  "about.valueInnovation": "Innovacion",
  "about.valueInnovationDesc": "Tecnologia de punta y metodologias avanzadas para anticipar amenazas.",
  "about.valueCommitment": "Compromiso",
  "about.valueCommitmentDesc": "Cada cliente es un socio. Su seguridad es nuestra prioridad absoluta.",
  "about.certificationsLabel": "Certificaciones",
  "about.isoCertified": "Certificado",

  // Ecosystem
  "eco.tag": "Soluciones integradas",
  "eco.title": "Ecosistema de",
  "eco.highlight": "Soluciones",
  "eco.subtitle": "Seis pilares de ciberseguridad interconectados que protegen cada capa de tu infraestructura digital, desde el endpoint hasta la nube.",
  "eco.centerName": "Openlab Secure",
  "eco.explore": "Explorar",
  "eco.tagline": "Cada pilar se fortalece con los demas · Arquitectura de seguridad holistica",

  // Services (section headers)
  "services.tag": "Soluciones",
  "services.title": "Soluciones de",
  "services.highlight": "Ciberseguridad",
  "services.subtitle": "Protegemos los activos digitales mas criticos de organizaciones lideres en Latinoamerica con tecnologia de punta",
  "services.specialistsBar": "+200 especialistas · 5 paises · 24/7",
  "services.servicesTitle": "Nuestros",
  "services.servicesHighlight": "Servicios Ciberseguridad",
  "services.servicesSubtitle": "Desde consultoria estrategica hasta operacion continua, cubrimos todo el espectro de necesidades de seguridad digital de tu organizacion.",
  "services.viewSolution": "Ver solucion",
  "services.viewService": "Ver servicio",
  "services.moreServices": "servicios mas...",

  // Capacitaciones
  "training.title": "Secure Academy",
  "training.subtitle": "Programas de entrenamiento disenados por nuestros expertos para fortalecer las capacidades de ciberseguridad de tu equipo.",
  "training.students": "Alumnos",
  "training.duration": "Duracion",
  "training.rating": "Rating",
  "training.demand": "Nivel de demanda",
  "training.demandHigh": "Alta",
  "training.viewCourse": "Ver curso",

  // Datacenter
  "dc.tag": "Infraestructura",
  "dc.title": "Soluciones de",
  "dc.highlight": "Datacenter",
  "dc.subtitle": "Un ecosistema integral de servicios de infraestructura y tecnologia para impulsar la transformacion digital de tu organizacion",
  "dc.viewSolution": "Ver solucion",
  "dc.exploreAll": "Explorar todas las soluciones de Datacenter",

  // Industries (Nuestros Clientes)
  "industries.tag": "Sectores que confian en nosotros",
  "industries.title": "Nuestros",
  "industries.highlight": "Clientes",
  "industries.subtitle": "Mas de 200 organizaciones en 11 sectores estrategicos confian en nuestras soluciones de ciberseguridad de clase mundial",
  "industries.clickHint": "Haz clic en cualquier sector para ver detalles",
  "industries.stat1": "+200 organizaciones",
  "industries.stat2": "11 sectores estratégicos",
  "industries.stat3": "5 países · 2 continentes",

  // CTA Banner
  "cta.tag": "Consultoria gratuita",
  "shared.ctaPrimary": "Ver +",
  "shared.ctaSecondary": "Habla con un experto",
  "cta.title": "Openlab Secure brinda soluciones",
  "cta.highlight": "para cada necesidad",
  "cta.subtitle": "Hacemos que la tecnologia simplifique tu vida mientras protegemos cada capa de tu infraestructura digital con los mas altos estandares de seguridad.",
  "cta.button": "Solicitar consultoria gratuita",
  "cta.consultantName": "Samara Mendoza",
  "cta.consultantRole": "Directora de Consultoría",
  "cta.response": "Respuesta",
  "cta.responseTime": "< 15 min",

  // Quick Actions
  "quick.title": "Que quieres hacer ahora?",
  "quick.viewMore": "Ver mas",

  // Contact
  "contact.tag": "Comunicate",
  "contact.title": "Listo para",
  "contact.highlight": "protegerte?",
  "contact.subtitle": "Nuestro equipo de expertos esta listo para blindar tu organizacion con soluciones de primer nivel",
  "contact.email": "Email",
  "contact.availability": "Disponibilidad",
  "contact.availabilityValue": "Lunes - Viernes · 24/7 SOC",
  "contact.coverage": "Cobertura",
  "contact.coverageValue": "America y Europa",
  "contact.followUs": "Siguenos",
  "contact.fullname": "Nombres y apellidos",
  "contact.fullnamePlaceholder": "Ej. Juan Carlos Rodriguez Lopez",
  "contact.emailLabel": "Email",
  "contact.emailPlaceholder": "tu@empresa.com",
  "contact.whatsapp": "WhatsApp",
  "contact.phone": "Telefono (celular)",
  "contact.phonePlaceholder": "+51 999 999 999",
  "contact.ruc": "RUC",
  "contact.rucPlaceholder": "Ej. 20548796321",
  "contact.company": "Empresa",
  "contact.companyPlaceholder": "Nombre de tu empresa",
  "contact.service": "Servicio de interes",
  "contact.serviceDefault": "Selecciona un servicio",
  "contact.message": "Mensaje (opcional)",
  "contact.messagePlaceholder": "Cuentanos sobre tu proyecto o consulta...",
  "contact.maxChars": "Maximo 500 caracteres",
  "contact.send": "Enviar mensaje",
  "contact.sending": "Enviando...",
  "contact.successTitle": "Mensaje enviado!",
  "contact.successMsg": "Gracias por contactarnos. Te responderemos en breve.",
  "contact.sendAnother": "Enviar otro mensaje",
  "contact.errorDefault": "Error al enviar el mensaje. Por favor intenta de nuevo.",
  "contact.connectionError": "Error de conexion. Por favor intenta de nuevo mas tarde.",
  "contact.rateLimited": "Demasiados intentos seguidos. Espera un minuto e intenta de nuevo.",
  "contact.consentPre": "Al enviar, acepto la",
  "contact.consentAnd": "y los",

  // Contact page (internal)
  "contactPage.tag": "Contáctanos",
  "contactPage.title": "Hablemos de la",
  "contactPage.highlight": "seguridad de tu empresa",
  "contactPage.subtitle": "Contanos tu desafío y un especialista te responde con una propuesta a medida en menos de 24 horas.",
  "contactPage.scrollForm": "Ir al formulario",

  // Location map (Contact page)
  "location.tag": "Presencia global",
  "location.title": "Nuestras",
  "location.highlight": "Oficinas",
  "location.subtitle": "Facilitamos la continuidad operativa ante cualquier incidencia, minimizando el impacto para nuestros clientes. Nuestra cobertura se extiende a lo largo del pais y del continente.",
  "location.intlTitle": "Presencia Internacional",
  "location.intlDesc": "Pasa el cursor sobre los puntos",
  "location.nationalTitle": "Cobertura Nacional",
  "location.nationalDesc": "Pasa el cursor sobre los puntos",
  "location.intlOfficesTitle": "Oficinas Internacionales",
  "location.nationalOfficesTitle": "Sedes Nacionales",
  "location.intlOfficesSub": "Equipos locales en 5 paises",
  "location.nationalOfficesSub": "Presencia en 3 ciudades del pais",
  "location.teamLabel": "Equipos locales en 5 paises",
  "location.live": "En vivo",
  "location.exploreLabel": "Explora nuestra red",
  "location.people.card1Title": "Equipo SOC 24/7",
  "location.people.card1Sub": "Detras de cada alerta",
  "location.people.card2Title": "Soporte en terreno",
  "location.people.card2Sub": "Cerca de tu operacion",
  "location.countryLabel": "paises",
  "location.siteLabel": "sedes",
  "location.stat.countries": "Paises",
  "location.stat.countriesDesc": "Presencia regional",
  "location.stat.sites": "Sedes",
  "location.stat.sitesDesc": "Operacion local",
  "location.stat.soc": "SOC 24/7",
  "location.stat.socDesc": "Monitoreo continuo",
  "location.statLabel": "Nuestra red en numeros",
  "location.country.pe": "Peru",
  "location.country.cl": "Chile",
  "location.country.ec": "Ecuador",
  "location.country.us": "EE.UU.",
  "location.country.co": "Colombia",
  "location.city.lima": "Lima",
  "location.city.santiago": "Santiago",
  "location.city.quito": "Quito",
  "location.city.miami": "Miami",
  "location.city.bogota": "Bogota",
  "location.city.arequipa": "Arequipa",
  "location.city.cusco": "Cusco",
  "location.role.hq": "Sede Central",
  "location.role.south": "Oficina Regional Sur",

  // Footer
  "footer.about": "Acerca de Openlab Secure",
  "footer.sales": "Contratacion y Ventas",
  "footer.contact": "Contáctanos",
  "footer.followUs": "Siguenos",
  "footer.legal": "Legales",
  "footer.rights": "Todos los derechos reservados",
  "footer.tagline": "Centro de Excelencia en Ciberseguridad",

  // Cookies
  "cookies.title": "Tu privacidad importa",
  "cookies.description": "Utilizamos cookies y tecnologias similares para mejorar tu experiencia, personalizar contenido y analizar el trafico. Podes aceptar todas, rechazarlas o gestionar tus preferencias.",
  "cookies.accept": "Aceptar todas",
  "cookies.reject": "Rechazar",
  "cookies.preferences": "Preferencias",
  "cookies.prefsTitle": "Preferencias de cookies",
  "cookies.essential": "Cookies esenciales",
  "cookies.essentialDesc": "Necesarias para que el sitio funcione correctamente. No se pueden desactivar.",
  "cookies.alwaysOn": "Siempre activas",
  "cookies.analytics": "Cookies de analisis",
  "cookies.analyticsDesc": "Nos ayudan a entender como interactuas con el sitio para mejorarlo.",
  "cookies.marketing": "Cookies de marketing",
  "cookies.marketingDesc": "Permiten mostrarte contenido relevante y publicidad personalizada.",
  "cookies.cancel": "Cancelar",
  "cookies.savePrefs": "Guardar preferencias",
};